import { render, staticRenderFns } from "./OpenBookingDetail.vue?vue&type=template&id=556d7dc2&scoped=true"
import script from "./OpenBookingDetail.vue?vue&type=script&lang=js"
export * from "./OpenBookingDetail.vue?vue&type=script&lang=js"
import style0 from "./OpenBookingDetail.vue?vue&type=style&index=0&id=556d7dc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d7dc2",
  null
  
)

export default component.exports